
import { defineComponent } from "vue";
import HomeBroadcastPlay from "./HomeBroadcastPlay.vue";
export default defineComponent({
  components: { HomeBroadcastPlay },
});
